(() => {
  if (window.lrlGiftWidgetInitialized) return;
  window.lrlGiftWidgetInitialized = true;
  const sessionKey = 'lrl-gift-promotion-shown-v1';
  const delay = 10000;
  let autoTimer = null;
  let storageReady = false;
  let shownThisSession = false;
  let returnFocus = null;
  let restoreFocus = true;
  try {
    shownThisSession = window.sessionStorage.getItem(sessionKey) === '1';
    storageReady = true;
  } catch {}
  const getDialog = () => document.getElementById('lrl-gift-dialog');
  const visibleFocusTarget = element => {
    if (!element?.isConnected || element === document.body || element.closest?.('[hidden], [inert], [aria-hidden="true"]')) return false;
    const rect = element.getBoundingClientRect?.();
    return !!rect && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  };
  const setExpanded = value => document.querySelectorAll('[data-lrl-gift]').forEach(trigger => trigger.setAttribute('aria-expanded', String(value)));
  const cancelTimer = () => {
    if (autoTimer !== null) window.clearTimeout(autoTimer);
    autoTimer = null;
  };
  const rememberShown = () => {
    shownThisSession = true;
    cancelTimer();
    try { window.sessionStorage.setItem(sessionKey, '1'); return true; }
    catch { storageReady = false; return false; }
  };
  const close = (focus = true) => {
    const dialog = getDialog();
    restoreFocus = focus;
    if (dialog?.open) dialog.close();
  };
  const cleanUp = () => {
    document.documentElement.classList.remove('lrl-gift-open');
    setExpanded(false);
    const focusTarget = visibleFocusTarget(returnFocus) ? returnFocus : document.querySelector('[data-lrl-gift]');
    if (restoreFocus && returnFocus && focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
    returnFocus = null;
    restoreFocus = true;
  };
  const show = trigger => {
    const dialog = getDialog();
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
    returnFocus = trigger || (visibleFocusTarget(document.activeElement) ? document.activeElement : null) || document.querySelector('[data-lrl-gift]');
    restoreFocus = true;
    dialog.showModal();
    dialog.scrollTop = 0;
    document.documentElement.classList.add('lrl-gift-open');
    setExpanded(true);
    dialog.querySelector('[data-lrl-gift-close]')?.focus({ preventScroll: true });
    return true;
  };
  const canAutoOpen = () => {
    if (document.visibilityState === 'hidden' || window.Shopify?.designMode) return false;
    if (/\/(?:cart|checkout|checkouts)(?:\/|$)/i.test(window.location.pathname)) return false;
    if (document.activeElement?.matches?.('input, textarea, select, [contenteditable="true"], [contenteditable=""]')) return false;
    if (document.querySelector('dialog[open], #flo-cart-wrapper.flo-cart-active, .jdgm-revs-tab__wrapper.jdgm-show')) return false;
    return ![...document.querySelectorAll('[aria-modal="true"]')].some(element => element.getClientRects().length > 0);
  };
  const startTimer = (restored = false) => {
    cancelTimer();
    if (shownThisSession || !storageReady || window.Shopify?.designMode) return;
    const dialog = getDialog();
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
    const elapsed = !restored && navigation?.loadEventEnd > 0 ? Math.max(0, window.performance.now() - navigation.loadEventEnd) : 0;
    autoTimer = window.setTimeout(() => {
      autoTimer = null;
      if (shownThisSession || !canAutoOpen()) return;
      if (rememberShown()) show();
    }, Math.max(0, delay - elapsed));
  };
  document.addEventListener('click', event => {
    const dialog = getDialog();
    if (!dialog || !(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-lrl-gift]');
    if (trigger) {
      event.preventDefault();
      rememberShown();
      if (dialog.open) return close();
      if (typeof dialog.showModal !== 'function') {
        const cart = dialog.querySelector('[data-lrl-gift-cart]');
        if (cart) window.location.assign(cart.href);
        return;
      }
      show(trigger);
      return;
    }
    if (event.target.closest('[data-lrl-gift-close]')) return close();
    const cartLink = event.target.closest('[data-lrl-gift-cart]');
    if (cartLink && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      close(false);
      requestAnimationFrame(() => {
        const fallback = () => window.location.assign(cartLink.href);
        if (typeof window.handleFloCartBtn !== 'function') return fallback();
        try { Promise.resolve(window.handleFloCartBtn()).catch(fallback); } catch { fallback(); }
      });
      return;
    }
    if (event.target === dialog && dialog.open) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target.id === 'lrl-gift-dialog') { event.preventDefault(); close(); }
  }, true);
  document.addEventListener('close', event => {
    if (event.target.id === 'lrl-gift-dialog' && !event.target.open) cleanUp();
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector?.('#lrl-gift-dialog')) { cancelTimer(); close(false); cleanUp(); }
  });
  window.addEventListener('pagehide', () => { cancelTimer(); close(false); });
  window.addEventListener('popstate', () => { cancelTimer(); close(false); });
  window.addEventListener('pageshow', event => {
    if (!getDialog()?.open) cleanUp();
    if (event.persisted) startTimer(true);
  });
  if (document.readyState === 'complete') startTimer();
  else window.addEventListener('load', () => startTimer(), { once: true });
})();
